import React from 'react'
import Dispaly from './Dispaly'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const App = () => {
  return (
    <>
      
      <Dispaly/>
      <ToastContainer />
    </>
  )
}

export default App